<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Avatar from "@/components/widgets/avatar";
import RankingFoto from "@/components/widgets/ranking-foto";

export default {
  locales: {
    pt: {
      'My Account': 'Minha Conta',
      'Username': 'Usuário',
      'Name': 'Nome',
      'Cellphone': 'Celular',
      'Password': 'Senha',
    },
    es: {
      'My Account': 'Mi Cuenta',
      'Username': 'Nombre de Usuario',
      'Name': 'Nombre',
      'Cellphone': 'Celular',
    }
  },
  components: {
    Layout,
    Avatar,
    RankingFoto
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
    // O popup "envie sua foto" dos Rankings manda para /account#foto-ranking.
    if (this.$route.hash === "#foto-ranking") {
      this.$nextTick(() => {
        const el = document.getElementById("foto-ranking");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('My Account') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <Avatar></Avatar>
          </div>
          <div class="col-md-8 pt-md-5">
            <div class="row pt-3 pb-0 pl-3 pr-3">
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Name') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.name }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('CPF/CNPJ') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.person.number }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Email') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.email.address }}</p>
              </div>
              <div class="col-md-6 text-center-sm">
                <p class="mb-0 text-uppercase font-weight-normal card-title-desc">{{ t('Cellphone') }}</p>
                <p class="mb-3 font-weight-normal notranslate">{{ account.user.cellphone }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Foto para o Ranking: separada do avatar acima (onde muitos usam o brasão da Regional). -->
    <div v-if="'ranking_foto' in account.user" id="foto-ranking" class="card">
      <div class="card-body">
        <RankingFoto />
      </div>
    </div>

    <!--
      Privacidade e exclusao de conta.

      O link de exclusao precisa estar VISIVEL dentro do aplicativo: a diretriz
      5.1.1(v) da App Store exige isso de qualquer aplicativo que permita criar
      conta, e este painel tem cadastro publico. O revisor procura por ele — e a
      tela "Minha Conta" e o primeiro lugar onde qualquer um olharia.
    -->
    <div class="card">
      <div class="card-body">
        <h5 class="card-title mb-2">Privacidade</h5>
        <p class="card-title-desc mb-3">
          Leia a
          <a href="/privacidade" target="_blank" rel="noopener">politica de privacidade</a>
          para saber quais dados guardamos e por quanto tempo.
        </p>
        <router-link to="/conta/excluir" class="btn btn-outline-danger btn-sm">
          Excluir minha conta
        </router-link>
      </div>
    </div>
  </Layout>
</template>